import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 1000 }, // Hover delay in milliseconds
  };

  static targets = ['spinner'];

  initialize() {
    this.hoverTimer = null;
  }

  enter() {
    this.spinnerTarget.classList.remove('opacity-0');
    this.hoverTimer = setTimeout(() => {
      this.fetchContent();
    }, this.delayValue);
  }

  leave() {
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = null;
    }
    this.spinnerTarget.classList.add('opacity-0');
  }

  async fetchContent() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
        },
      });
      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
      }
    } finally {
      this.spinnerTarget.classList.add('opacity-0');
    }
  }
}
